<template>
  <v-container fluid>
    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}
      <v-btn text @click="snack = false">Close</v-btn>
    </v-snackbar>
    <v-card>
      <v-card-title>
        <v-toolbar>
        <v-row justify="space-between">
          <v-col cols="12" sm="6" md="4">
            Rake No: {{curDeviceName}}
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
          <!-- <v-col>
            <v-dialog v-model="adhoc_dialog" max-width="850px">
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="adhoc_on">Add Goods Train</v-btn>
              </template>
              <v-card>
                <v-card-text>
                 <v-form v-model="adhoc_valid">
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" md="3">
                        <v-text-field v-model="editedItem.train_no" label="Train No" outlined readonly></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="3">
                        <v-text-field v-model="editedItem.train_no_text" label="Train Name" outlined readonly></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="3">
                        <v-text-field v-model="editedItem.org" label="ORG" outlined readonly></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="2">
                        <VueCtkDateTimePicker id="stDate" v-model="editedItem.dep" format="DD/MM/YYYY HH:mm" />
                      </v-col>
                      <v-col cols="12" sm="6" md="3">
                        <v-text-field v-model="editedItem.org" label="DEST" outlined readonly></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="2">
                        <VueCtkDateTimePicker id="endDate" v-model="editedItem.arr" format="DD/MM/YYYY HH:mm" />
                      </v-col>
                    </v-row>
                </v-container>
              </v-form>
              </v-card-text>

              <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn color="blue darken-1" text @click="adhoc_close">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="adhoc_save" :disabled="!adhoc_valid">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          </v-col> -->
          <v-col>
            <v-dialog v-model="dialog" max-width="850px">
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on">Add Train</v-btn>
              </template>
              <v-card>
                <v-card-text>
                 <v-form v-model="valid">
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-menu
                            ref="menu1"
                            v-model="menu1"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            full-width
                            max-width="400px"
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="dateFormatted"
                                label="Train Date"
                                hint="DD/MM/YYYY format"
                                persistent-hint
                                required
                                :rules="dateRules"
                                prepend-icon="event"
                                @blur="editedItem.train_date = parseDate(dateFormatted)"
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker v-model="editedItem.train_date" no-title @input="menu1 = false"></v-date-picker>
                          </v-menu>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field  v-model="editedItem.train_no" label="Train No" @input="queryTrain($event)" :rules="trainNoRules" required></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="3">
                        <v-text-field v-model="editedItem.train_no_text" label="Train Name" ></v-text-field>
                      </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field v-model="editedItem.org" label="ORG" ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <masked-input v-model="editedItem.dep" label="DEP" mask="11:11" placeholder="Dep" style="font-size: 12pt;padding: 13px;border-bottom:2px solid #4fc08d;width:75pt" />
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field v-model="editedItem.dest" label="DEST"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <masked-input v-model="editedItem.arr" label="Arr" mask="11:11" placeholder="Arr" style="font-size: 12pt;padding: 13px;border-bottom:2px solid #4fc08d;width:75pt" />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field v-model="editedItem.pf" label="PF No" ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field v-model="editedItem.next_train_no" label="Next Trian No" ></v-text-field>
                        </v-col>
                      </v-row>
                  </v-container>
                </v-form>
                </v-card-text>

                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                  <v-btn color="blue darken-1" text @click="save" :disabled="!valid">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
      </v-toolbar>
      </v-card-title>
  <v-data-table
    :headers="headers"
    :items="trains"
    :search="search"
    :footer-props="{
    'items-per-page-options': [10, 20, 30, 40, 50]
    }"
    :items-per-page="40"
    sort-by="calories"
    class="elevation-1"
    @click:row="onRowClick($event)"
  >
    <template v-slot:item.train_date="{ item }">
      {{getFormattedDate(item.train_date)}}
    </template>
    <template v-slot:item.dep="{ item }">
      {{getFormattedTime(item.dep)}}
    </template>
    <template v-slot:item.arr="{ item }">
      {{getFormattedTime(item.arr)}}
    </template>
    <template v-slot:item.insert_time_local="{ item }">
      {{getFormattedDateTime(item.insert_time_local)}}
    </template>
    <template v-slot:item.action="{ item }">
      <v-btn text icon color="blue" dark @click.native.stop="editItem(item)">
        <v-icon dark>mdi-pencil</v-icon>
      </v-btn>
      <v-btn text icon color="red" dark @click.native.stop="deleteItem(item)">
        <v-icon dark>mdi-delete</v-icon>
      </v-btn>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template>
  </v-data-table>
</v-card>
</v-container>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import { mapState, mapGetter, mapActions } from 'vuex'
import MaskedInput from 'vue-masked-input'
export default {
  name: 'trains',
  components: {
    MaskedInput
  },
  data () {
    return {
      valid: true,
      search: '',
      dateRules: [v => !!v || 'Date is required'],
      trainNoRules: [v => !!v || 'Train No is required'],
      dialog: false,
      errors: [],
      headers: [
        {
          text: 'Train Date',
          align: 'left',
          sortable: true,
          value: 'train_date',
        },
          {
            text: 'Train No',
            align: 'left',
            sortable: true,
            value: 'train_no',
          },
          {
            text: 'Train Name',
            align: 'left',
            sortable: true,
            value: 'train_no_text',
          },
          { text: 'ORG', value: 'org' },
          { text: 'Dep.', value: 'dep' },
          { text: 'DEST', value: 'dest' },
          { text: 'Arr.', value: 'arr' },
          { text: 'Add Time', value: 'insert_time_local' },
          { text: 'Actions', value: 'action', sortable: false },
          ],
      train: {},
      train_loading: false,
      trains: [],
      dateFormatted: moment().format('DD/MM/YYYY'),
      editedIndex: -1,
      editedItem: {
        train_date: moment().format('YYYY-MM-DD'),
        train_no:'',
        division:'',
        zone:'',
        train_no_text:'',
        org: '',
        dep: '',
        dest: '',
        arr: '',
        pf: '',
        next_train_no: ''
      },
      defaultItem: {
        train_date: moment().format('YYYY-MM-DD'),
        train_no:'',
        division:'',
        zone:'',
        train_no_text:'',
        org: '',
        dep: '',
        dest: '',
        arr: '',
        pf: '',
        next_train_no: ''
      },
      snack: false,
      snackColor: '',
      snackText: '',
      menu1: false,
      menu2: false,
      }
  },
  computed: {
    ...mapState(['curDeviceId', 'curDeviceName', 'curTrainNo', 'curTrainDate', 'curOrg', 'curArr', 'curDest','curDep']),
     formTitle () {
       return this.editedIndex === -1 ? 'Add Train' : 'Edit Train'
     },
     computedDateFormatted () {
         return this.formatDate(this.editItem.train_date)
       },
   },

   watch: {
     dialog (val) {
       val || this.close()
     },
     editedItem (val) {
       this.dateFormatted = this.getFormattedDate(val.train_date)
     },
   },

   created () {
     this.initialize()
   },

  methods: {
    ...mapActions(['updateCurDeviceId', 'updateCurDeviceName', 'updateCurTrainNo', 'updateCurTrainDate', 'updateCurOrg', 'updateCurArr', 'updateCurDest', 'updateCurDep']),
    formatDate (date) {
        if (!date) return null
        return moment(date).format('DD/MM/YYYY')
      },
      parseDate (date) {
        if (!date) return null
        return moment(date, ['DD/MM/YYYY']).format('YYYY-MM-DD')
      },
      initialize() {
//      console.log(this.curDeviceId)
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
      axios.get(`${process.env.VUE_APP_API_URL}/train/${this.curDeviceId}`)
      .then(response => {
        console.log(response);
        this.trains = []
        this.trains = response.data
      })
      .catch(e => {
        this.errors.push(e)
        if(e.response.status === 401) {
          this.$router.push({
            name: 'Login'
          })
        }
      })
    },
    queryTrain($event) {
      axios.get(`${process.env.VUE_APP_API_URL}/timetable/${$event}`)
      .then(response => {
        console.log(response);
        if ( response.data[0]) {
          this.valid = true
          this.editItem.division = response.data[0].divn
          this.editItem.zone = response.data[0].zone
          this.editedItem.org = response.data[0].org
          this.editedItem.dep = response.data[0].dep
          this.editedItem.dest = response.data[0].dest
          this.editedItem.arr = response.data[0].arr
          this.editedItem.pf = response.data[0].pf
          this.editedItem.next_train_no = response.data[0].next_train_no
        } else {
          // this.valid =false
          this.editItem.division = null
          this.editItem.zone = null
          this.editedItem.org = null
          this.editedItem.dep = null
          this.editedItem.dest = null
          this.editedItem.arr = null
          this.editedItem.pf = null
          this.editedItem.next_train_no = null
        }
      })
      .catch(e => {
        this.errors.push(e)
      })
    },
    editItem (item) {
       this.editedIndex = this.trains.indexOf(item)
       this.editedItem = Object.assign({}, item)
       this.editedItem.dep = this.getFormattedTime(item.dep)
       this.editedItem.arr = this.getFormattedTime(item.arr)
       console.log(this.editedItem)
       this.dialog = true
     },

     deleteItem (item) {
       const index = this.trains.indexOf(item)
       var train_device_map = {
           id: item.id,
         }
       if (confirm('Are you sure you want to delete this item?')) {
         axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
         axios.delete(`${process.env.VUE_APP_API_URL}/train/`, {params: train_device_map})
         .then(response => {
           //alert("Registered successfully")
            this.trains.splice(index, 1)
           })
         .catch(e => {
           console.log(e)
           this.errors.push(e)
         })

       }
     },

     close () {
       this.dialog = false
       setTimeout(() => {
         this.editedItem = Object.assign({}, this.defaultItem)
         this.editedIndex = -1
       }, 300)
     },
//update traccar_db.device_train_map set dep = addtime(train_date, time(dep)), arr = addtime(train_date, time(arr));
//update traccar_db.device_train_map set arr = adddate(arr, 1) where arr < dep;
     save () {

       var dep = moment(this.editedItem.train_date).format("YYYY-MM-DD") + ' ' + this.editedItem.dep
       var arr = moment(this.editedItem.train_date).format("YYYY-MM-DD") + ' ' + this.editedItem.arr
       if (moment(dep) > moment(arr)) {
         arr = moment(arr).add(1, 'days').format("YYYY-MM-DD HH:mm:ss")
       }
       console.log(dep, arr)
       var update_time = moment().tz('Asia/Kolkata').format('YYYY-MM-DD HH:mm:ss')
       var train_device_map = {
         train_date: moment(this.editedItem.train_date).format("YYYY-MM-DD"),
         train_no: this.editedItem.train_no,
         zone: this.editItem.zone,
         division: this.editItem.division,
         device_id: this.curDeviceId,
         device_name: this.curDeviceName,
         unique_device_id: this.curDeviceId,
         org: this.editedItem.org,
         dep: dep,
         dest: this.editedItem.dest,
         arr: arr ,
         pf: this.editedItem.pf,
         next_train_no: this.editedItem.next_train_no,
         insert_time: update_time,
         update_time: update_time,
       }
       if (this.editedIndex > -1) {
         train_device_map.id = this.editedItem.id
         axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
         axios.put(`${process.env.VUE_APP_API_URL}/train/`, train_device_map)
         .then(response => {
           //alert("Registered successfully")
           console.log(response)
           //  this.editedItem.dep = dep
           //  this.editedItem.arr = arr
           //  Object.assign(this.trains[this.editedIndex], this.editedItem)
           this.initialize()
           })
         .catch(e => {
           console.log(e.response)
           this.snackColor = 'error'
           this.snackText = e.response.data.error
           this.snack = true
           this.errors.push(e)
         })

       } else {
         //console.log(train_device_map)
         axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')

         axios.post(`${process.env.VUE_APP_API_URL}/train/`, train_device_map)
         .then(response => {
          // this.trains.push(this.editedItem)
        //  this.trains.unshift(train_device_map)
          this.initialize()
          //alert("Registered successfully")
           })
         .catch(e => {
           console.log(e.response)
           this.snackColor = 'error'
           this.snackText = e.response.data.error
           this.snack = true
           this.errors.push(e)
         })

       }
       this.close()
     },
     onRowClick($event) {
       console.log($event);
       this.updateCurTrainDate(moment($event.train_date).format("YYYY-MM-DD"))
       this.updateCurOrg($event.org)
       this.updateCurDep($event.dep)
       this.updateCurDest($event.dest)
       this.updateCurArr($event.arr)
       this.$router.push({ name: 'Positions', query: {
         train_no:$event.train_no,
         device_id: this.curDeviceId,
         device_name: this.curDeviceName
       }})
     },
     getFormattedDate(t) {
       var lt = moment(t).format("YYYY-MM-DD HH:mm:ss")
       var testDateUtc = moment.utc(lt);
       var localDate = moment(testDateUtc).local();
       return localDate.format("DD/MM/YYYY")
     },
     getFormattedDateTime(t) {
       if (t != null) {
        //  var lt = moment(t).format("YYYY-MM-DD HH:mm:ss")
        //  var testDateUtc = moment.utc(lt);
        // var localDate = moment(testDateUtc).local();
        //  return moment(localDate).format("HH:mm:ss")
        return moment.utc(t).format("DD/MM/YYYY HH:mm:ss")
       }
     },
     getFormattedTime(t) {
        return moment.utc(t).format("HH:mm:ss")
     }
    }
}
</script>
